import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a46cdaec&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a46cdaec')) {
      api.createRecord('a46cdaec', component.options)
    } else {
      api.reload('a46cdaec', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a46cdaec&", function () {
      api.rerender('a46cdaec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21t6ySJ1Sh13S/JS/comp/ImgFallback.vue"
export default component.exports